/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders icon and text if none job is selected on job search.
 */

import React from 'react';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import Image from '~/jobiqo/components/Image';
import styles from './jobSearchEmptyCustom.module.scss';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div className={styles.emptySearchWrapper}>
      <Image
        alt={'Job search image'}
        src={'/static/logo.png'}
        width={180}
        height={180}
      />
      <Spacing size="medium" />
      <RichFormattedMessage
        id="job_detail_panel_instructions"
        defaultMessage="To see all the details of a job posting please choose one from the list on the left."
      />
    </div>
  );
};
export default JobSearchEmptySlot;
